<script setup>
defineProps({
  search: String,
  method: String,
  status: String,
  methodOptions: {
    type: Array,
    default: () => [],
  },
  statusOptions: {
    type: Array,
    default: () => [],
  },
});

defineEmits(["update:search", "update:method", "update:status", "reset"]);
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 mb-4">
    <div class="card-body p-4">
      <div class="row g-3 align-items-end">
        <div class="col-lg-5">
          <label class="form-label fw-semibold text-secondary">ค้นหา</label>
          <div class="input-group">
            <span class="input-group-text bg-white">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="ค้นหาจากเลขที่รับชำระ ใบแจ้งหนี้ ลูกบ้าน ยูนิต หรือใบเสร็จ"
              :value="search"
              @input="$emit('update:search', $event.target.value)"
            />
          </div>
        </div>

        <div class="col-lg-3">
          <label class="form-label fw-semibold text-secondary"
            >ช่องทางชำระ</label
          >
          <select
            class="form-select"
            :value="method"
            @change="$emit('update:method', $event.target.value)"
          >
            <option
              v-for="option in methodOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-lg-3">
          <label class="form-label fw-semibold text-secondary">สถานะ</label>
          <select
            class="form-select"
            :value="status"
            @change="$emit('update:status', $event.target.value)"
          >
            <option
              v-for="option in statusOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-lg-1">
          <button
            type="button"
            class="btn btn-light border w-100 rounded-3"
            @click="$emit('reset')"
            title="ล้างตัวกรอง"
          >
            <i class="bi bi-arrow-clockwise"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
